<template>
    <div>
        <div class="agx-list-oneInRow"
            v-bind:style="{ 'background': 'url(' + item.thumbPath + ')', 'height': '250px', 'background-size': '100% auto' }">
            <div>
                <div style="border-bottom: 1px solid #ececec;text-align: center;">
                    <div>
                        <router-link :to="{ name: targetPage, query: { postId: item.postId } }">
                            <!-- <img style="display: inline-block; height: 80px; border-radius: 10px; box-shadow: 10px 5px 5px #ececec;"
                                class="img-reponsive" :src="item.thumbPath" :title="item.title"> -->
                            <span v-if="item.thumbPath === null"
                                style="display: inline-block; font-weight: bolder; text-align: center; width: 80px; height: 80px; line-height: 80px; font-size: 60px; border: 1px solid gray; border-radius: 4px; box-shadow: 10px 5px 5px #ececec;">
                                <span v-if="item.title !== null && item.title.length > 0">{{ item.title[0] }}</span>
                            </span>
                        </router-link>
                    </div>
                    <!-- <div style="padding:2px;text-align: left;background: rgba(0, 0, 0, 0.6);">
                        <router-link :to="{ name: targetPage, query: { postId: item.postId } }">
                            <span style="font-weight:bolder;color: white;">{{ item.title }}</span>
                        </router-link>
                    </div> -->
                </div>

                <div
                    style="width:100%;position: absolute; left: 0px; right: 0px; bottom: 0px;background: rgba(0, 0, 0, 0.6);color: white;">
                    <div style="z-index:999;">
                        <div
                            style="font-size: 1.2em; margin:2px 7px;display: inline-flex;flex-direction: row;border: 1px solid gray;padding: 4px;">
                            <div style="padding:0px 4px;" class="agx-theme-bg">{{ item.parentCategory.name }}</div>
                            <div style="border-left:1px solid gray;padding:0px 8px;">{{ item.category.name }}</div>
                        </div>

                        <price-tag :item="item"></price-tag>
                    </div>
                    <post-label :item="item"></post-label>
                    <post-tag :item="item"></post-tag>
                    <div style="padding:2px;text-align: center;background: white;">
                        <router-link :to="{ name: targetPage, query: { postId: item.postId } }">
                            <span class="form-control" style="font-weight:bolder;">{{ item.title }}</span>
                        </router-link>
                    </div>
                    <!-- <div>{{ item.textMsg }}</div> -->
                </div>
                <!-- <div
                    style="position: absolute; left: 0px; right: 0px; bottom: 0px;height: 24px; background: #ececec;box-shadow: 0px -10px 15px #ececec;text-align:center;">
                    <span style="color:gray;font-size:12px;">Update:{{ item.zoneEditDatetime }}</span>
                </div> -->
            </div>

        </div>
    </div>
</template>
<script>

import PriceTag from '../PriceTag.vue';
import PostTag from '../PostTag.vue';
import PostLabel from '../PostLabel.vue';

export default {
    components: {
        PostLabel,
        PriceTag,
        PostTag
    },
    filters: {
        cutContent: function (txtMsg) {
            if (txtMsg === null) return;
            var length = 150;
            return txtMsg.length > length ? txtMsg.slice(0, length) + "......" : txtMsg;
        }
    },
    props: ["item", "listingType"],
    computed: {
        targetPage: function () {
            if (this.listingType === 'listing') {
                return "detail";
            }
            return "articleDetail";
        }
    },
    data: function () {
        return {

        }
    },
    mounted: function () {

    }
}
</script>